<script setup lang="ts">
import { Button, LinkButton } from "@soft-db/ui";

defineProps<{ page: string }>();

const { t } = useI18n();
const router = useRouter();
</script>

<template>
	<div class="flex size-full flex-col items-center justify-center gap-2">
		<h1 class="text-primary text-4xl">{{ page }} {{ t("common.notFound").toLowerCase() }}</h1>
		<p>{{ t("notFound.description") }}</p>
		<div class="flex gap-1">
			<Button color="primary" @click="router.back"> {{ t("dashboard.goBack") }} </Button>
			<LinkButton to="/" color="primary"> {{ t("notFound.button") }} </LinkButton>
		</div>
	</div>
</template>
